"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../../utils");

/**
 *
 * A helper function to transform a redux-form field name into a label string 
 * by stripping its namespace and converting it to start case. 
 * 
 * @name convertNameToLabel
 * @type Function
 * @param {String} name - A redux-form field name
 * @returns {String} - A user-friendly field label
 * @example
 * 
 * convertNameToLabel('example') // -> 'Example'
 * convertNameToLabel('person.firstName') // -> 'First Name'
 *
 */
function convertNameToLabel(name) {
  return (0, _utils.startCase)((0, _utils.stripNamespace)(name));
}

var _default = convertNameToLabel;
exports["default"] = _default;